namespace $ {
	export class $shm_surreal_profile extends $mol_object {

		static storage_key( id: string ) {
			return `$shm_surreal_profile:${ id }`
		}

		@ $mol_mem_key
		static data( id: string, next?: $shm_surreal_config_profile_data | null ) {
			const key = this.storage_key( id )
			if( next !== undefined ) return $mol_state_local.value( key, next ) as $shm_surreal_config_profile_data | null
			const stored = $mol_state_local.value( key ) as $shm_surreal_config_profile_data | null
			if( stored ) return stored
			if( id === 'local' ) return {
				endpoint: 'ws://127.0.0.1:18000',
				namespace: 'hitalama',
				database: 'hitalama',
				username: 'root',
				password: 'root',
			}
			return null
		}

		static public_data( id: string ) {
			const profile = this.data( id )
			if( !profile ) return null
			const { password, token, ...public_data } = profile
			return public_data
		}
	}
}
